import Vue from 'vue'
import VtTextarea from '@/components/common/VtTextarea.vue'
Vue.component('VtTextarea', VtTextarea)
